export default __webpack_public_path__ + "static/media/moot-court-2.0f8caebe.webp";